import React from 'react';
import { withFormsy } from 'formsy-react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { FormHelperText } from '@mui/material';
import moment from 'moment';

const format = 'DD/MM/YYYY';

class DateInput extends React.Component {
  constructor(props) {
    super(props);

    this.changeValue = this.changeValue.bind(this);
    this.defaultDate = this.defaultDate.bind(this);

    this.props.setValue(this.defaultDate());
  }

  changeValue(event) {
    this.props.setValue(event.format());
  }

  defaultDate() {
    if (this.props.minDate) {
      return this.props.minDate;
    }
    return new Date(new Date().setHours(0,0,0,0));
  }

  render() {
    const { name, label, hint, minDate, maxDate, errorMessage, isPristine, value } = this.props;
    const isError = !isPristine && errorMessage != null;

    return (
      <div className="input-container">
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DatePicker
            label={label}
            value={moment(value) || this.defaultDate()}
            onChange={this.changeValue}
            slotProps={{ textField: { fullWidth: true } }}
            format={format}
            minDate={moment(minDate)}
            maxDate={moment(maxDate)}
          />
        </LocalizationProvider>

        {!isPristine && errorMessage &&
          <FormHelperText error={isError} className="input-error">{errorMessage}</FormHelperText>
        }
        {hint &&
          <FormHelperText>{hint}</FormHelperText>
        }
      </div>
    )
  }
}

export default withFormsy(DateInput);
